import $t from '../common/i18n';
import { ref, onBeforeMount } from 'vue-demi';
const {
    lang: { LANG_ENUM }
} = require('@futuweb/fego-bridge');
const { useEnv, useLang, useCommonApi } = require('@fegobull/webapi').use;
const { isPreRender } = useEnv();
const { lang } = useLang();
const request = useCommonApi('quotes-card-v2');

// 英文单位 十亿、百万
const billion = Math.pow(10, 9);
const million = Math.pow(10, 6);
const enFormatArr = [
    { unit: billion, unitName: $t('billion') },
    { unit: million, unitName: $t('million') }
];

// 中文单位 亿、万
const tenMillion = Math.pow(10, 8);
const tenThousand = Math.pow(10, 4);
const cnFormatArr = [
    { unit: tenMillion, unitName: $t('tenMillion') },
    { unit: tenThousand, unitName: $t('tenThousand') }
];

const aumFormatMap = {
    [LANG_ENUM.CN]: cnFormatArr,
    [LANG_ENUM.HK]: cnFormatArr,
    [LANG_ENUM.JA]: cnFormatArr,
    [LANG_ENUM.EN]: enFormatArr,
    [LANG_ENUM.FR]: enFormatArr
};

// aum的格式化方法，单位由高到低取
const aumFormatFn = (aum) => {
    const formatArr = aumFormatMap[lang];
    for (let i = 0; i < formatArr.length; i++) {
        const { unit, unitName } = formatArr[i];
        if (aum / unit > 1) {
            return `${(aum / unit).toFixed(2)}${unitName}`;
        }
    }
    // 如果低于小于单位，原数返回
    return aum;
};

export default (props) => {
    const loaded = ref(false);

    const stockQuote = ref({
        symbol: $t('loading'),
        name: $t('loading'),
        rateStr: '--%',
        rate: 0,
        aum: 0,
        dividendYield: 0
    });

    const formatData = (data) => {
        // 涨跌幅
        if (data.rate) {
            data.rateStr = (data.rate > 0 ? '+' : '') + `${(data.rate * 100).toFixed(2)}%`;
        } else {
            data.rateStr = '--%';
        }
        // 股息率
        if (data.dividendYield) {
            data.dividendYield = (data.dividendYield * 100).toFixed(2) + '%';
        }
        // 资产
        if (data.aum) {
            data.aum = aumFormatFn(data.aum);
        }
        return data;
    };

    const getStockQuote = async () => {
        const data = {
            stockId: props.stockId,
            lang,
            increaseType: props.increaseType
        };
        try {
            const rspData = await request.get('get-stock-quote', data);
            stockQuote.value = formatData(rspData);
            loaded.value = true;
        } catch (err) {
            console.error('get-stock-quote_error', err);
        }
    };

    !isPreRender && props.stockId && onBeforeMount(getStockQuote);

    return {
        loaded,
        stockQuote
    };
};
